import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { Toaster } from "@/components/ui/sonner";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";

import Home from "@/pages/Home";
import ConsultationPage from "@/pages/ConsultationPage";
import FundraiserPage from "@/pages/FundraiserPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/legal/PrivacyPage";
import CookiesPage from "@/pages/legal/CookiesPage";
import TermsPage from "@/pages/legal/TermsPage";
import AccessibilityPage from "@/pages/legal/AccessibilityPage";
import ComplaintsProcedure from "@/pages/legal/ComplaintsProcedure";
import NotFound from "@/pages/NotFound";
import LoginPage from "@/pages/LoginPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import SiteSettingsPage from "@/pages/SiteSettingsPage";

function App() {
  return (
    <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/book-a-consultation" element={<ConsultationPage />} />
            <Route path="/join-our-team" element={<FundraiserPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/complaints" element={<ComplaintsProcedure />} />
            <Route path="*" element={<NotFound />} />
          </Route>

          {/* Admin — auth scoped to these routes only so public pages never call /auth/me */}
          <Route
            path="/site-settings/login"
            element={
              <AuthProvider>
                <LoginPage />
              </AuthProvider>
            }
          />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/site-settings"
            element={
              <AuthProvider>
                <ProtectedRoute>
                  <SiteSettingsPage />
                </ProtectedRoute>
              </AuthProvider>
            }
          />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </SettingsProvider>
  );
}

export default App;
